import {faComment} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {getMenuItemNameForAnalytics} from '@rdcomponents/navigation/navigation-helper';
import {nameForAnalytics} from '@rdcomponents/navigation/navigation-type';

import {appRoute} from '../../../../app-route';
import {CreateReview} from '../../../../page/main/reviews/custom-review-page/form/create/create-review';
import {EditReviewPageGuard} from '../../../../page/main/reviews/custom-review-page/form/edit/edit-review-page-guard';
import {Reviews} from '../../../../page/main/reviews/reviews';
import {ReviewsReviewItemRoute} from '../../../../page/main/reviews/reviews-review-item-route';
import {ReviewsAndAnswersStatistics} from '../../../../page/main/reviews-and-answers-statistics/reviews-and-answers-statistics';
import {TagCreate} from '../../../../page/main/tags/tag-create/tag-create';
import {TagEdit} from '../../../../page/main/tags/tag-edit/tag-edit';
import {Tags} from '../../../../page/main/tags/tags';
import {TagsEdit} from '../../../../page/main/tags-edit/tags-edit';
import {useLicenses} from '../../../../provider/license/license-hook';
import {useLocale} from '../../../../provider/locale/locale-hook';
import {FeaturesEnum} from '../../../../service/user/user-type';
import {NavigationItemConfigType} from '../routing-type';

export function useReviewsManagementNavigation(): Array<NavigationItemConfigType> {
    const {licenses, availableFeatures, enabledFeatures} = useLicenses();

    const {getLocalizedString} = useLocale();

    return [
        {
            isAvailable: availableFeatures[FeaturesEnum.reviews] && enabledFeatures.includes(FeaturesEnum.reviews),
            path: appRoute.reviewsManagement.path,
            icon: <FontAwesomeIcon icon={faComment} />,
            label: getLocalizedString('CATEGORY_NAME__WORKING_WITH_REVIEWS'),
            [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__WORKING_WITH_REVIEWS'),
            redirectPath: appRoute.reviewsManagementReviews.path,
            deniedPath: [appRoute.reviewsManagement.path],

            children: [
                {
                    isOnlyRoute: true,
                    path: appRoute.reviewsManagementReviewItem.path,
                    exact: true,
                    component: ReviewsReviewItemRoute,
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__REVIEWS__REVIEW_DETAILS'),
                },
                {
                    path: appRoute.reviewsManagementReviews.path,
                    isActivated: licenses[FeaturesEnum.reviews]?.isActive,
                    label: getLocalizedString('CATEGORY_NAME__REVIEWS'),
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__REVIEWS'),
                    component: Reviews,
                    exact: false,
                },
                {
                    path: appRoute.reviewsManagementTags.path,
                    label: getLocalizedString('CATEGORY_NAME__TAGS'),
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__TAGS'),
                    component: Tags,
                    exact: true,
                },
                {
                    isOnlyRoute: true,
                    path: appRoute.reviewsManagementTagsEdit.path,
                    exact: true,
                    component: TagsEdit,
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__TAGS__EDIT_GROUP'),
                },
                {
                    isOnlyRoute: true,
                    path: appRoute.reviewsManagementCreateReview.path,
                    exact: true,
                    component: CreateReview,
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__REVIEWS__CREATE_REVIEW'),
                },
                {
                    isOnlyRoute: true,
                    path: appRoute.reviewsManagementEditReview.path,
                    exact: true,
                    component: EditReviewPageGuard,
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__REVIEWS__EDIT_REVIEW'),
                },
                {
                    isOnlyRoute: true,
                    path: appRoute.reviewsManagementTagCreate.path,
                    exact: true,
                    component: TagCreate,
                    [nameForAnalytics]: getMenuItemNameForAnalytics('TAGS__CREATING'),
                },
                {
                    isOnlyRoute: true,
                    path: appRoute.reviewsManagementTagEdit.path,
                    exact: true,
                    component: TagEdit,
                    [nameForAnalytics]: getMenuItemNameForAnalytics('TAGS__UPDATING'),
                },
                {
                    path: appRoute.reviewsManagementReviewsAndAnswersStatistics.path,
                    label: getLocalizedString('CATEGORY_NAME__REVIEWS_AND_ANSWERS_STATISTICS__NAVIGATION'),
                    [nameForAnalytics]: getMenuItemNameForAnalytics(
                        'CATEGORY_NAME__REVIEWS_AND_ANSWERS_STATISTICS__NAVIGATION'
                    ),
                    component: ReviewsAndAnswersStatistics,
                    exact: true,
                },
            ],
        },
    ];
}
